import { RouterChild } from '@/router';

export default [
  { name: 'contact-address-list', path: 'address-list', component: () => import('./views/List.vue') } as RouterChild
];
